export const getEmployeeLoanList = state => {
    return state.list
}

export const getEmployeeLoanDataProps = state => {
    return state.props
}

export const getEmployeeLoanBalance = state => {
    return state.props.loan_balance
}


// WEBPACK FOOTER //
// ./src/store/modules/employeeLoan/getters.js